import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { useSiteData } from '../lib/SiteDataContext';

const { ArrowUpRight, Building2 } = Icons;

const MinistriesGrid = ({ heading = true }) => {
  const { ministries, settings } = useSiteData();
  const hs = settings?.home_sections || {};
  const sorted = (ministries || []).slice().sort((a, b) => a.order - b.order);
  return (
    <section className="bg-[#F2EBD8] py-24">
      <div className="mx-auto max-w-[1280px] px-6">
        {heading && (
          <div className="mb-12">
            <div className="mb-3 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#C9A86A]">
              {hs.ministries_eyebrow || 'Government Ministries'}
            </div>
            <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
              <h2 className="max-w-2xl font-serif text-3xl font-bold leading-tight text-[#0B2545] md:text-[40px]">
                {hs.ministries_title || 'Serving the people through dedicated institutions'}
              </h2>
              <p className="max-w-md text-[15px] leading-relaxed text-[#0B2545]/70">
                {hs.ministries_description}
              </p>
            </div>
            <div className="mt-6 h-[3px] w-16 bg-[#C9A86A]" />
          </div>
        )}

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {sorted.map((m) => {
            const Icon = Icons[m.icon] || Building2;
            return (
              <Link
                key={m.id || m.slug}
                to={`/ministries/${m.slug}`}
                className="group relative flex items-start gap-4 overflow-hidden rounded-lg border border-[#E6DDC8] bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-[#C9A86A] hover:shadow-lg"
              >
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-[#F6F2EA] text-[#C9A86A] transition-colors group-hover:bg-[#C9A86A] group-hover:text-white">
                  <Icon size={20} />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-[14px] font-semibold leading-snug text-[#0B2545]">{m.name}</div>
                </div>
                <ArrowUpRight size={16} className="shrink-0 text-[#C9A86A] opacity-70 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MinistriesGrid;
